import React from 'react';
import Button from '@mui/material/Button';
import ChatIcon from '@mui/icons-material/Chat';
import { ADVISOR_AVAILABILITY } from 'libs/constants';

type ChatButtonProps = {
  chatAvailability: number;
  listingId: number;
  pmode: boolean;
  chatTrackingSource: number;
  eligibleForFeaturedListingClicks: boolean;
  parentCategoryId: number;
  flBidId: number;
  onChatButtonClick?: any;
};

export default function ChatButton({
  chatAvailability,
  listingId,
  pmode,
  chatTrackingSource,
  eligibleForFeaturedListingClicks,
  flBidId,
  parentCategoryId,
  onChatButtonClick
}: ChatButtonProps): JSX.Element {
  const { takingChat, offline, arrangeChats } =
    ADVISOR_AVAILABILITY.chatAvailability;

  const getChatButtonUrl = () => {
    let url = `
      /Chat/ChatSetup.aspx
      ?sid=${listingId}
      &pmode=${pmode}
      &webtrack=${chatTrackingSource}
    `
      .replaceAll('\n', '')
      .replaceAll(' ', '');
    if (eligibleForFeaturedListingClicks && flBidId > 0) {
      url += `&category=${parentCategoryId}`;
    }
    return url;
  };

  const getArrangeChatUrl = () => {
    const url = `
      /app/#/arrange-conversation/details
      ?ctype=chat
      &listingid=${listingId}
      &pmode=${pmode}
      &webtrack=${chatTrackingSource}
    `
      .replaceAll('\n', '')
      .replaceAll(' ', '');
    return url;
  };

  const onButtonClick = (availability, redirectUrl) => {
    if (onChatButtonClick) onChatButtonClick(availability);
    window.location.assign(redirectUrl);
  };

  switch (chatAvailability) {
    case takingChat:
      return (
        <Button
          variant="primary"
          disableElevation
          size="medium"
          fullWidth
          startIcon={<ChatIcon className="icon" />}
          onClick={() => onButtonClick(chatAvailability, getChatButtonUrl())}>
          Chat Now
        </Button>
      );
    case offline:
      return (
        <div className="chat-later-container">
          <Button
            className="chat-later"
            variant="secondary"
            disableElevation
            size="medium"
            fullWidth
            startIcon={<ChatIcon className="icon" />}
            disabled>
            Chat Later
          </Button>
        </div>
      );
    case arrangeChats:
    default:
      return (
        <Button
          className="arrange-chat"
          variant="outlined"
          disableElevation
          size="medium"
          fullWidth
          startIcon={<ChatIcon className="icon" />}
          onClick={() => onButtonClick(chatAvailability, getArrangeChatUrl())}>
          Arrange Chat
        </Button>
      );
  }
}

ChatButton.defaultProps = {
  onChatButtonClick: null
};
